import {
  Price,
  PriceCurrent,
  PriceBefore,
  PricePercentOff,
} from '@virginexperiencedays/components-v2/src/pages/product/PricingModule/v2';
import { getProductCardPrices } from '@virginexperiencedays/components-v2/src/utils/productPricing';

import type { HTMLAttributes } from 'react';

type PriceWidgetProps = {
  displayPrice: number;
  rrp: number;
  percentOff: number;
} & HTMLAttributes<HTMLElement>;

// Matched logic from packages/libs/components-v2/src/cards/ProductV2/index.tsx
export const PriceWidget = ({ displayPrice, rrp, percentOff, className }: PriceWidgetProps) => {
  const { currentPrice, pastPrice, roundedPercentOff } = getProductCardPrices({
    displayPrice,
    rrp,
    percentOff,
  });

  const hasDiscount = !!pastPrice || !!percentOff;

  return (
    <Price className={className}>
      <PriceCurrent>{currentPrice}</PriceCurrent>
      {hasDiscount && (
        <div className="flex flex-nowrap gap-1">
          {!!pastPrice && <PriceBefore>{pastPrice}</PriceBefore>}
          {!!percentOff && <PricePercentOff>Save {roundedPercentOff}%</PricePercentOff>}
        </div>
      )}
    </Price>
  );
};
